import { render, staticRenderFns } from "./ErrorBar.vue?vue&type=template&id=308c491a&scoped=true&"
import script from "./ErrorBar.vue?vue&type=script&lang=js&"
export * from "./ErrorBar.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBar.vue?vue&type=style&index=0&id=308c491a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c491a",
  null
  
)

export default component.exports